diy.angular.registerFactory('diyfilename', [function() {

    /**
     * takes a filename as a parameter, returns it as an object containing
     *  {
     *      name: filename
     *      extension: .jpg (or empty string if no extension)
     *  }
     * @param fileName the filename
     * @returns {{name: *, extension: *}}
     */
    var parse = function(fileName) {
        var extensionRegex = /\.[a-zA-Z0-9]{1,5}$/;
        /* check if this file has an extension and store it */
        var extension = fileName.match(extensionRegex);
        /* if it does, remove it from the file name */
        if (Array.isArray(extension) && extension.length > 0) {
            fileName = fileName.replace(extensionRegex, '');
        }
        return {
            name: fileName,
            extension: (Array.isArray(extension) && extension.length > 0) ? extension[0] : ''
        };
    };

    /**
     * takes a filename object containing name and extension as keys
     * and returns a concatenated filename based on the two keys
     * while performing some slight adjustments
     *
     * stringify({name: 'asdf.jpg', extension: '.jpg'}) => asdf.jpg
     * stringify({name: 'asdf.jpg', extension: '.png'}) => asdf.png
     * stringify({name: 'asdf', extension: '.gif'}) => asdf.gif
     *
     * @param fileNameObject the key-value name and extension object
     * @returns {string}
     */
    var stringify = function(fileNameObject) {
        var result = '';

        /* parse the name, as the user may have put an extension inside the name */
        var nameobject = parse(fileNameObject.name);
        /* if he did, use only the name, not the extension */
        if (nameobject.extension) {
            result+= nameobject.name;
        } else {
            result+= fileNameObject.name;
        }
        /* append extension, if any */
        if (fileNameObject.extension) {
            result+= fileNameObject.extension;
        }

        return result;
    };

    return {
        parse: parse,
        stringify: stringify
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/angular/services/diyfilename.js
 ** module id = 934
 ** module chunks = 0
 **/